<template>
  <div>
    <v-divider style="margin-top: 70px"></v-divider>
    <div style="font-size: 14px; text-align: center">
      Created with Love in Brazil & France
    </div>
    <v-divider></v-divider>

    <!-- Buttons on footer -->
    <v-footer color="purple darken-4" padless>
      <!--  -->
      <v-row justify="center" no-gutters>
        <v-btn color="white" text rounded class="my-2" x-small>
          <a href="/" style="text-decoration: none;color:white;">
            {{ $t("Home.MenuHome.home") }}</a
          ></v-btn
        >

        <v-btn color="white" text rounded class="my-2" x-small>
          <a href="/products/nownow" style="text-decoration: none;color:white;">
            {{ $t("Home.MenuHome.product") }}</a
          ></v-btn
        >

        <v-btn color="white" text rounded class="my-2" x-small
          ><a href="/products/whatsapplink" style="text-decoration:none;color:white;">
            {{ $t("Home.MenuHome.ProdWhats") }}</a
          ></v-btn
        >

        <v-btn color="white" text rounded class="my-2" x-small
          ><a
            href="https://docs.google.com/forms/d/e/1FAIpQLSfZzuQsw3aXz682A1GGG4498myPthxrsgk7MwJURzve2vULzw/viewform"
            style="text-decoration: none;color:white;"
          >
            {{ $t("Home.Footer.ReportProblem") }}</a
          ></v-btn
        >

        <v-btn color="white" text rounded class="my-2" x-small
          ><a
            href="https://www.nownow.tech/terms"
            style="text-decoration: none;color:white;"
            >{{ $t("Home.Footer.TermsOfService") }}</a
          ></v-btn
        >

        <v-btn color="white" text rounded class="my-2" x-small
          ><a
            href="https://www.nownow.tech/privacy"
            style="text-decoration: none;color:white;"
            >{{ $t("Home.Footer.PrivacyPolicy") }}</a
          ></v-btn
        >

        <!-- Set preferred language -->
        <v-col
          class="text-center white"
          cols="12"
          style="font-size: 14px; padding: 5px"
        >
          <v-btn
            color="purple darken-4"
            text
            rounded
            class="my-2"
            @click="setEnglish"
            x-small
            >{{ $t("Home.MenuHome.english") }}</v-btn
          >

          <v-btn
            color="purple darken-4"
            text
            rounded
            class="my-2"
            @click="setPortuguese"
            x-small
            >{{ $t("Home.MenuHome.portuguese") }}</v-btn
          >

          <v-btn
            color="purple darken-4"
            text
            rounded
            class="my-2"
            @click="setSpanish"
            x-small
            >{{ $t("Home.MenuHome.spanish") }}</v-btn
          >
        </v-col>
        <v-col
          class="text-center white"
          cols="12"
          style="font-size: 14px; padding: 5px"
        >
          {{ new Date().getFullYear() }} —
          <strong>NowNow</strong>
        </v-col>
      </v-row>
    </v-footer>
  </div>
</template>

<script>
export default {
  methods: {
    setEnglish() {
      this.$i18n.locale = "en";
      localStorage.locale = "en";
    },
    setPortuguese() {
      this.$i18n.locale = "pt";
      localStorage.locale = "pt";
    },
    setSpanish() {
      this.$i18n.locale = "es";
      localStorage.locale = "es";
    },
  },
};
</script>

<style>
.footer {
  font-family: open sans;
  font-size: 12px;
  margin: 10px 20px 10px 20px;
}

.link-footer {
  text-decoration: none;
  color: black !important;
}
</style>